(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[437],{

/***/ 13824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ attractions; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-disposables.js
var use_disposables = __webpack_require__(94192);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-id.js
var use_id = __webpack_require__(19946);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-iso-morphic-effect.js
var use_iso_morphic_effect = __webpack_require__(16723);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-computed.js
var use_computed = __webpack_require__(71646);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-sync-refs.js
var use_sync_refs = __webpack_require__(23784);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/render.js
var render = __webpack_require__(12351);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/match.js
var match = __webpack_require__(32984);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/disposables.js
var disposables = __webpack_require__(9362);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/keyboard.js
var keyboard = __webpack_require__(61363);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/calculate-active-index.js
var calculate_active_index = __webpack_require__(11497);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/bugs.js
var bugs = __webpack_require__(64103);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/focus-management.js
var focus_management = __webpack_require__(84575);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/internal/open-closed.js
var open_closed = __webpack_require__(16567);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-resolve-button-type.js
var use_resolve_button_type = __webpack_require__(14157);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-outside-click.js
var use_outside_click = __webpack_require__(90292);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/internal/hidden.js
var internal_hidden = __webpack_require__(46045);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/form.js
var utils_form = __webpack_require__(18689);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/owner.js
var owner = __webpack_require__(15466);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-event.js
var use_event = __webpack_require__(73781);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/components/listbox/listbox.js
var ce=(n=>(n[n.Open=0]="Open",n[n.Closed=1]="Closed",n))(ce||{}),fe=(n=>(n[n.Single=0]="Single",n[n.Multi=1]="Multi",n))(fe||{}),be=(n=>(n[n.Pointer=0]="Pointer",n[n.Other=1]="Other",n))(be||{}),Te=(r=>(r[r.OpenListbox=0]="OpenListbox",r[r.CloseListbox=1]="CloseListbox",r[r.SetDisabled=2]="SetDisabled",r[r.SetOrientation=3]="SetOrientation",r[r.GoToOption=4]="GoToOption",r[r.Search=5]="Search",r[r.ClearSearch=6]="ClearSearch",r[r.RegisterOption=7]="RegisterOption",r[r.UnregisterOption=8]="UnregisterOption",r))(Te||{});function H(t,i=n=>n){let n=t.activeOptionIndex!==null?t.options[t.activeOptionIndex]:null,e=(0,focus_management/* sortByDomNode */.z2)(i(t.options.slice()),p=>p.dataRef.current.domRef.current),o=n?e.indexOf(n):null;return o===-1&&(o=null),{options:e,activeOptionIndex:o}}let xe={[1](t){return t.disabled||t.listboxState===1?t:{...t,activeOptionIndex:null,listboxState:1}},[0](t){if(t.disabled||t.listboxState===0)return t;let i=t.activeOptionIndex,{value:n,mode:e,compare:o}=t.propsRef.current,p=t.options.findIndex(l=>{let s=l.dataRef.current.value;return (0,match/* match */.E)(e,{[1]:()=>n.some(r=>o(r,s)),[0]:()=>o(n,s)})});return p!==-1&&(i=p),{...t,listboxState:0,activeOptionIndex:i}},[2](t,i){return t.disabled===i.disabled?t:{...t,disabled:i.disabled}},[3](t,i){return t.orientation===i.orientation?t:{...t,orientation:i.orientation}},[4](t,i){var o;if(t.disabled||t.listboxState===1)return t;let n=H(t),e=(0,calculate_active_index/* calculateActiveIndex */.d)(i,{resolveItems:()=>n.options,resolveActiveIndex:()=>n.activeOptionIndex,resolveId:p=>p.id,resolveDisabled:p=>p.dataRef.current.disabled});return{...t,...n,searchQuery:"",activeOptionIndex:e,activationTrigger:(o=i.trigger)!=null?o:1}},[5]:(t,i)=>{if(t.disabled||t.listboxState===1)return t;let e=t.searchQuery!==""?0:1,o=t.searchQuery+i.value.toLowerCase(),l=(t.activeOptionIndex!==null?t.options.slice(t.activeOptionIndex+e).concat(t.options.slice(0,t.activeOptionIndex+e)):t.options).find(u=>{var r;return!u.dataRef.current.disabled&&((r=u.dataRef.current.textValue)==null?void 0:r.startsWith(o))}),s=l?t.options.indexOf(l):-1;return s===-1||s===t.activeOptionIndex?{...t,searchQuery:o}:{...t,searchQuery:o,activeOptionIndex:s,activationTrigger:1}},[6](t){return t.disabled||t.listboxState===1||t.searchQuery===""?t:{...t,searchQuery:""}},[7]:(t,i)=>{let n={id:i.id,dataRef:i.dataRef},e=H(t,o=>[...o,n]);if(t.activeOptionIndex===null){let{value:o,mode:p,compare:l}=t.propsRef.current,s=i.dataRef.current.value;(0,match/* match */.E)(p,{[1]:()=>o.some(r=>l(r,s)),[0]:()=>l(o,s)})&&(e.activeOptionIndex=e.options.indexOf(n))}return{...t,...e}},[8]:(t,i)=>{let n=H(t,e=>{let o=e.findIndex(p=>p.id===i.id);return o!==-1&&e.splice(o,1),e});return{...t,...n,activationTrigger:1}}},j=(0,react.createContext)(null);j.displayName="ListboxContext";function w(t){let i=(0,react.useContext)(j);if(i===null){let n=new Error(`<${t} /> is missing a parent <Listbox /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(n,w),n}return i}function ye(t,i){return (0,match/* match */.E)(i.type,xe,t,i)}let Oe=react.Fragment,me=(0,render/* forwardRefWithAs */.yV)(function(i,n){let{value:e,name:o,onChange:p,disabled:l=!1,horizontal:s=!1,multiple:u=!1,...r}=i;const x=s?"horizontal":"vertical";let A=(0,use_sync_refs/* useSyncRefs */.T)(n),R=(0,react.useReducer)(ye,{listboxState:1,propsRef:{current:{value:e,onChange:p,mode:u?1:0,compare:(0,use_event/* useEvent */.z)((y,m)=>y===m)}},labelRef:(0,react.createRef)(),buttonRef:(0,react.createRef)(),optionsRef:(0,react.createRef)(),disabled:l,orientation:x,options:[],searchQuery:"",activeOptionIndex:null,activationTrigger:1}),[{listboxState:b,propsRef:O,optionsRef:T,buttonRef:d},a]=R;O.current.value=e,O.current.mode=u?1:0,(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>{O.current.onChange=y=>(0,match/* match */.E)(O.current.mode,{[0](){return p(y)},[1](){let m=O.current.value.slice(),C=m.indexOf(y);return C===-1?m.push(y):m.splice(C,1),p(m)}})},[p,O]),(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>a({type:2,disabled:l}),[l]),(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>a({type:3,orientation:x}),[x]),(0,use_outside_click/* useOutsideClick */.O)([d,T],(y,m)=>{var C;a({type:1}),(0,focus_management/* isFocusableElement */.sP)(m,focus_management/* FocusableMode.Loose */.tJ.Loose)||(y.preventDefault(),(C=d.current)==null||C.focus())},b===0);let c=(0,react.useMemo)(()=>({open:b===0,disabled:l}),[b,l]),D={ref:A};return react.createElement(j.Provider,{value:R},react.createElement(open_closed/* OpenClosedProvider */.up,{value:(0,match/* match */.E)(b,{[0]:open_closed/* State.Open */.ZM.Open,[1]:open_closed/* State.Closed */.ZM.Closed})},o!=null&&e!=null&&(0,utils_form/* objectToFormEntries */.t)({[o]:e}).map(([y,m])=>react.createElement(internal_hidden/* Hidden */._,{features:internal_hidden/* Features.Hidden */.A.Hidden,...(0,render/* compact */.oA)({key:y,as:"input",type:"hidden",hidden:!0,readOnly:!0,name:y,value:m})})),(0,render/* render */.sY)({ourProps:D,theirProps:r,slot:c,defaultTag:Oe,name:"Listbox"})))}),ge="button",Re=(0,render/* forwardRefWithAs */.yV)(function(i,n){var T;let[e,o]=w("Listbox.Button"),p=(0,use_sync_refs/* useSyncRefs */.T)(e.buttonRef,n),l=`headlessui-listbox-button-${(0,use_id/* useId */.M)()}`,s=(0,use_disposables/* useDisposables */.G)(),u=(0,use_event/* useEvent */.z)(d=>{switch(d.key){case keyboard/* Keys.Space */.R.Space:case keyboard/* Keys.Enter */.R.Enter:case keyboard/* Keys.ArrowDown */.R.ArrowDown:d.preventDefault(),o({type:0}),s.nextFrame(()=>{e.propsRef.current.value||o({type:4,focus:calculate_active_index/* Focus.First */.T.First})});break;case keyboard/* Keys.ArrowUp */.R.ArrowUp:d.preventDefault(),o({type:0}),s.nextFrame(()=>{e.propsRef.current.value||o({type:4,focus:calculate_active_index/* Focus.Last */.T.Last})});break}}),r=(0,use_event/* useEvent */.z)(d=>{switch(d.key){case keyboard/* Keys.Space */.R.Space:d.preventDefault();break}}),x=(0,use_event/* useEvent */.z)(d=>{if((0,bugs/* isDisabledReactIssue7711 */.P)(d.currentTarget))return d.preventDefault();e.listboxState===0?(o({type:1}),s.nextFrame(()=>{var a;return(a=e.buttonRef.current)==null?void 0:a.focus({preventScroll:!0})})):(d.preventDefault(),o({type:0}))}),A=(0,use_computed/* useComputed */.v)(()=>{if(!!e.labelRef.current)return[e.labelRef.current.id,l].join(" ")},[e.labelRef.current,l]),R=(0,react.useMemo)(()=>({open:e.listboxState===0,disabled:e.disabled}),[e]),b=i,O={ref:p,id:l,type:(0,use_resolve_button_type/* useResolveButtonType */.f)(i,e.buttonRef),"aria-haspopup":!0,"aria-controls":(T=e.optionsRef.current)==null?void 0:T.id,"aria-expanded":e.disabled?void 0:e.listboxState===0,"aria-labelledby":A,disabled:e.disabled,onKeyDown:u,onKeyUp:r,onClick:x};return (0,render/* render */.sY)({ourProps:O,theirProps:b,slot:R,defaultTag:ge,name:"Listbox.Button"})}),Le="label",ve=(0,render/* forwardRefWithAs */.yV)(function(i,n){let[e]=w("Listbox.Label"),o=`headlessui-listbox-label-${(0,use_id/* useId */.M)()}`,p=(0,use_sync_refs/* useSyncRefs */.T)(e.labelRef,n),l=(0,use_event/* useEvent */.z)(()=>{var x;return(x=e.buttonRef.current)==null?void 0:x.focus({preventScroll:!0})}),s=(0,react.useMemo)(()=>({open:e.listboxState===0,disabled:e.disabled}),[e]);return (0,render/* render */.sY)({ourProps:{ref:p,id:o,onClick:l},theirProps:i,slot:s,defaultTag:Le,name:"Listbox.Label"})}),Se="ul",Ae=render/* Features.RenderStrategy */.AN.RenderStrategy|render/* Features.Static */.AN.Static,he=(0,render/* forwardRefWithAs */.yV)(function(i,n){var d;let[e,o]=w("Listbox.Options"),p=(0,use_sync_refs/* useSyncRefs */.T)(e.optionsRef,n),l=`headlessui-listbox-options-${(0,use_id/* useId */.M)()}`,s=(0,use_disposables/* useDisposables */.G)(),u=(0,use_disposables/* useDisposables */.G)(),r=(0,open_closed/* useOpenClosed */.oJ)(),x=(()=>r!==null?r===open_closed/* State.Open */.ZM.Open:e.listboxState===0)();(0,react.useEffect)(()=>{var c;let a=e.optionsRef.current;!a||e.listboxState===0&&a!==((c=(0,owner/* getOwnerDocument */.r)(a))==null?void 0:c.activeElement)&&a.focus({preventScroll:!0})},[e.listboxState,e.optionsRef]);let A=(0,use_event/* useEvent */.z)(a=>{switch(u.dispose(),a.key){case keyboard/* Keys.Space */.R.Space:if(e.searchQuery!=="")return a.preventDefault(),a.stopPropagation(),o({type:5,value:a.key});case keyboard/* Keys.Enter */.R.Enter:if(a.preventDefault(),a.stopPropagation(),e.activeOptionIndex!==null){let{dataRef:c}=e.options[e.activeOptionIndex];e.propsRef.current.onChange(c.current.value)}e.propsRef.current.mode===0&&(o({type:1}),(0,disposables/* disposables */.k)().nextFrame(()=>{var c;return(c=e.buttonRef.current)==null?void 0:c.focus({preventScroll:!0})}));break;case (0,match/* match */.E)(e.orientation,{vertical:keyboard/* Keys.ArrowDown */.R.ArrowDown,horizontal:keyboard/* Keys.ArrowRight */.R.ArrowRight}):return a.preventDefault(),a.stopPropagation(),o({type:4,focus:calculate_active_index/* Focus.Next */.T.Next});case (0,match/* match */.E)(e.orientation,{vertical:keyboard/* Keys.ArrowUp */.R.ArrowUp,horizontal:keyboard/* Keys.ArrowLeft */.R.ArrowLeft}):return a.preventDefault(),a.stopPropagation(),o({type:4,focus:calculate_active_index/* Focus.Previous */.T.Previous});case keyboard/* Keys.Home */.R.Home:case keyboard/* Keys.PageUp */.R.PageUp:return a.preventDefault(),a.stopPropagation(),o({type:4,focus:calculate_active_index/* Focus.First */.T.First});case keyboard/* Keys.End */.R.End:case keyboard/* Keys.PageDown */.R.PageDown:return a.preventDefault(),a.stopPropagation(),o({type:4,focus:calculate_active_index/* Focus.Last */.T.Last});case keyboard/* Keys.Escape */.R.Escape:return a.preventDefault(),a.stopPropagation(),o({type:1}),s.nextFrame(()=>{var c;return(c=e.buttonRef.current)==null?void 0:c.focus({preventScroll:!0})});case keyboard/* Keys.Tab */.R.Tab:a.preventDefault(),a.stopPropagation();break;default:a.key.length===1&&(o({type:5,value:a.key}),u.setTimeout(()=>o({type:6}),350));break}}),R=(0,use_computed/* useComputed */.v)(()=>{var a,c,D;return(D=(a=e.labelRef.current)==null?void 0:a.id)!=null?D:(c=e.buttonRef.current)==null?void 0:c.id},[e.labelRef.current,e.buttonRef.current]),b=(0,react.useMemo)(()=>({open:e.listboxState===0}),[e]),O=i,T={"aria-activedescendant":e.activeOptionIndex===null||(d=e.options[e.activeOptionIndex])==null?void 0:d.id,"aria-multiselectable":e.propsRef.current.mode===1?!0:void 0,"aria-labelledby":R,"aria-orientation":e.orientation,id:l,onKeyDown:A,role:"listbox",tabIndex:0,ref:p};return (0,render/* render */.sY)({ourProps:T,theirProps:O,slot:b,defaultTag:Se,features:Ae,visible:x,name:"Listbox.Options"})}),Pe="li",De=(0,render/* forwardRefWithAs */.yV)(function(i,n){let{disabled:e=!1,value:o,...p}=i,[l,s]=w("Listbox.Option"),u=`headlessui-listbox-option-${(0,use_id/* useId */.M)()}`,r=l.activeOptionIndex!==null?l.options[l.activeOptionIndex].id===u:!1,{value:x,compare:A}=l.propsRef.current,R=(0,match/* match */.E)(l.propsRef.current.mode,{[1]:()=>x.some(S=>A(S,o)),[0]:()=>A(x,o)}),b=(0,react.useRef)(null),O=(0,use_sync_refs/* useSyncRefs */.T)(n,b);(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>{if(l.listboxState!==0||!r||l.activationTrigger===0)return;let S=(0,disposables/* disposables */.k)();return S.requestAnimationFrame(()=>{var L,K;(K=(L=b.current)==null?void 0:L.scrollIntoView)==null||K.call(L,{block:"nearest"})}),S.dispose},[b,r,l.listboxState,l.activationTrigger,l.activeOptionIndex]);let T=(0,react.useRef)({disabled:e,value:o,domRef:b});(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>{T.current.disabled=e},[T,e]),(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>{T.current.value=o},[T,o]),(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>{var S,L;T.current.textValue=(L=(S=b.current)==null?void 0:S.textContent)==null?void 0:L.toLowerCase()},[T,b]);let d=(0,use_event/* useEvent */.z)(()=>l.propsRef.current.onChange(o));(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>(s({type:7,id:u,dataRef:T}),()=>s({type:8,id:u})),[T,u]);let a=(0,use_event/* useEvent */.z)(S=>{if(e)return S.preventDefault();d(),l.propsRef.current.mode===0&&(s({type:1}),(0,disposables/* disposables */.k)().nextFrame(()=>{var L;return(L=l.buttonRef.current)==null?void 0:L.focus({preventScroll:!0})}))}),c=(0,use_event/* useEvent */.z)(()=>{if(e)return s({type:4,focus:calculate_active_index/* Focus.Nothing */.T.Nothing});s({type:4,focus:calculate_active_index/* Focus.Specific */.T.Specific,id:u})}),D=(0,use_event/* useEvent */.z)(()=>{e||r||s({type:4,focus:calculate_active_index/* Focus.Specific */.T.Specific,id:u,trigger:0})}),y=(0,use_event/* useEvent */.z)(()=>{e||!r||s({type:4,focus:calculate_active_index/* Focus.Nothing */.T.Nothing})}),m=(0,react.useMemo)(()=>({active:r,selected:R,disabled:e}),[r,R,e]);return (0,render/* render */.sY)({ourProps:{id:u,ref:O,role:"option",tabIndex:e===!0?void 0:-1,"aria-disabled":e===!0?!0:void 0,"aria-selected":R===!0?!0:void 0,disabled:void 0,onClick:a,onFocus:c,onPointerMove:D,onMouseMove:D,onPointerLeave:y,onMouseLeave:y},theirProps:p,slot:m,defaultTag:Pe,name:"Listbox.Option"})}),rt=Object.assign(me,{Button:Re,Label:ve,Options:he,Option:De});

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 3 modules
var transition = __webpack_require__(11355);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/solid/esm/SelectorIcon.js


function SelectorIcon(props, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = react.forwardRef(SelectorIcon);
/* harmony default export */ var esm_SelectorIcon = (ForwardRef);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/solid/esm/CheckIcon.js


function CheckIcon(props, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
    clipRule: "evenodd"
  }));
}

const CheckIcon_ForwardRef = react.forwardRef(CheckIcon);
/* harmony default export */ var esm_CheckIcon = (CheckIcon_ForwardRef);
// EXTERNAL MODULE: ./components/global/card.jsx + 1 modules
var card = __webpack_require__(13693);
// EXTERNAL MODULE: ./utils/intl.js
var intl = __webpack_require__(70590);
// EXTERNAL MODULE: ./utils/rideTypes.js
var rideTypes = __webpack_require__(13873);
// EXTERNAL MODULE: ./node_modules/graphql-request/dist/index.js
var graphql_request_dist = __webpack_require__(28687);
// EXTERNAL MODULE: ./queries/fragments/MainPhoto.js
var MainPhoto = __webpack_require__(20519);
// EXTERNAL MODULE: ./queries/fragments/ParkLite.js
var ParkLite = __webpack_require__(82202);
;// CONCATENATED MODULE: ./queries/attractions.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        "\n    ",
        "\n\n    query Attraction($limit: Int, $start: Int",
        "",
        ") {\n      attractionsCount",
        "",
        "",
        '\n      attractions(\n        sort: "Slug:asc"\n        limit: $limit\n        start: $start\n        ',
        "\n        ",
        "\n        ",
        "\n      ) {\n        Name\n        Slug\n        id\n        Park {\n          ...ParkLite\n        }\n        CoverPhoto {\n          ...MainPhoto\n        }\n        MainPhoto {\n          ...MainPhoto\n        }\n      }\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function ATTRACTIONS_QUERY() {
    var manufacturerQuery = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, typeFilter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var query = (0,graphql_request_dist.gql)(_templateObject(), MainPhoto/* default */.Z, ParkLite/* default */.Z, manufacturerQuery ? ", $manufacturer: String" : "", typeFilter ? ", $type: String" : "", manufacturerQuery && !typeFilter ? "(where: { Manufacturers: $manufacturer })" : "", typeFilter && !manufacturerQuery ? "(where: { Type: $type })" : "", typeFilter && manufacturerQuery ? "(where: { Type: $type,  Manufacturers: $manufacturer })" : "", manufacturerQuery && !typeFilter ? "where: { Manufacturers: $manufacturer }" : "", typeFilter && !manufacturerQuery ? "where: { Type: $type }" : "", typeFilter && manufacturerQuery ? "where: { Manufacturers: $manufacturer, Type: $type }" : "");
    return query;
};

;// CONCATENATED MODULE: ./components/attractions/attractions.jsx










function Attractions(param1) {
    var manufacturer = param1.manufacturer;
    var ref;
    var ref1 = (0,react.useState)(1), currentPage = ref1[0], setCurrentPage = ref1[1];
    var ref2 = (0,react.useState)(""), currentTypeFilter = ref2[0], setCurrentTypeFilter = ref2[1];
    var ref3 = (0,react.useState)(0), nbPages = ref3[0], setNbPages = ref3[1];
    var ref4 = (0,react.useState)(""), selected1 = ref4[0], setSelected = ref4[1];
    var perPage = 30;
    var startRange = perPage * (currentPage - 1);
    var variables = {
        limit: perPage,
        start: startRange
    };
    if (manufacturer) {
        variables.manufacturer = manufacturer;
    }
    if (currentTypeFilter) {
        variables.type = currentTypeFilter;
    }
    var ref5 = (0,dist/* default */.ZP)([
        ATTRACTIONS_QUERY(!!manufacturer, !!currentTypeFilter),
        variables, 
    ]), data = ref5.data, error = ref5.error;
    if (error) {
        console.error(error);
    }
    (0,react.useEffect)(function() {
        setNbPages(Math.max((data === null || data === void 0 ? void 0 : data.attractionsCount) / perPage));
    }, [
        data === null || data === void 0 ? void 0 : data.attractionsCount
    ]);
    if (!Array.isArray(data === null || data === void 0 ? void 0 : data.attractions)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-8 flex w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "flex-grow self-center text-lg text-gray-700",
                        children: [
                            "Showing",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "font-mono",
                                children: [
                                    (0,intl/* formatNumber */.u)(startRange + 1),
                                    "-",
                                    (0,intl/* formatNumber */.u)(Math.min(startRange + perPage, data === null || data === void 0 ? void 0 : data.attractionsCount))
                                ]
                            }),
                            " ",
                            "of",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-mono",
                                children: (0,intl/* formatNumber */.u)(data === null || data === void 0 ? void 0 : data.attractionsCount)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-grow justify-end text-gray-700",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(rt, {
                            value: selected1,
                            onChange: function(value) {
                                setSelected(value);
                                setCurrentTypeFilter(value);
                                setCurrentPage(1);
                            },
                            children: function(param2) {
                                var open = param2.open;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(rt.Label, {
                                            className: "sr-only block text-sm font-medium text-gray-700",
                                            children: "Type:"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "relative",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(rt.Button, {
                                                    className: "relative w-full cursor-default rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 text-left shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 sm:text-sm",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "block truncate",
                                                            children: selected1 ? rideTypes/* default */.Z[selected1].name : "All"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_SelectorIcon, {
                                                                className: "h-5 w-5 text-gray-400",
                                                                "aria-hidden": "true"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                                                    show: open,
                                                    as: react.Fragment,
                                                    leave: "transition ease-in duration-100",
                                                    leaveFrom: "opacity-100",
                                                    leaveTo: "opacity-0",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(rt.Options, {
                                                        className: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(rt.Option, {
                                                                className: function(param) {
                                                                    var active = param.active;
                                                                    return classnames_default()(active ? "bg-indigo-600 text-white" : "text-gray-900", "relative cursor-default select-none py-2 pl-3 pr-9");
                                                                },
                                                                value: "",
                                                                children: function(param) {
                                                                    var selected = param.selected, active = param.active;
                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: classnames_default()(selected ? "font-semibold" : "font-normal", "block truncate"),
                                                                                children: "All"
                                                                            }),
                                                                            selected ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: classnames_default()(active ? "text-white" : "text-indigo-600", "absolute inset-y-0 right-0 flex items-center pr-4"),
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_CheckIcon, {
                                                                                    className: "h-5 w-5",
                                                                                    "aria-hidden": "true"
                                                                                })
                                                                            }) : null
                                                                        ]
                                                                    });
                                                                }
                                                            }, "ride-type-all"),
                                                            Object.keys(rideTypes/* default */.Z).map(function(type) {
                                                                if (type === "OTHER") {
                                                                    return null;
                                                                }
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(rt.Option, {
                                                                    className: function(param) {
                                                                        var active = param.active;
                                                                        return classnames_default()(active ? "bg-indigo-600 text-white" : "text-gray-900", "relative cursor-default select-none py-2 pl-3 pr-9");
                                                                    },
                                                                    value: type,
                                                                    children: function(param) {
                                                                        var selected = param.selected, active = param.active;
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: classnames_default()(selected ? "font-semibold" : "font-normal", "block truncate"),
                                                                                    children: rideTypes/* default */.Z[type].name
                                                                                }),
                                                                                selected ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: classnames_default()(active ? "text-white" : "text-indigo-600", "absolute inset-y-0 right-0 flex items-center pr-4"),
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_CheckIcon, {
                                                                                        className: "h-5 w-5",
                                                                                        "aria-hidden": "true"
                                                                                    })
                                                                                }) : null
                                                                            ]
                                                                        });
                                                                    }
                                                                }, "ride-type-".concat(type));
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                });
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-10 grid grid-cols-2 gap-8 md:grid-cols-3 lg:grid-cols-4",
                children: data === null || data === void 0 ? void 0 : (ref = data.attractions) === null || ref === void 0 ? void 0 : ref.map(function(attraction) {
                    if (!attraction.Park) {
                        console.warn("MISSING PARK", attraction);
                        return null;
                    }
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
                        link: "/park/".concat(attraction.Park.Slug, "/").concat(attraction.Slug),
                        title: attraction.Name,
                        image: attraction.MainPhoto,
                        type: "attraction",
                        additional: attraction.Park.Name
                    }, "attraction-".concat(attraction.id));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                className: "flex justify-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: classnames_default()("mx-1 select-none rounded-lg px-3 py-2", currentPage === 1 ? "bg-indigo-100 text-gray-500" : "bg-indigo-900 text-white"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: classnames_default()("flex items-center font-bold", currentPage === 1 ? "cursor-default" : ""),
                            onClickCapture: function(event) {
                                event.preventDefault();
                                if (currentPage === 1) {
                                    return false;
                                }
                                setCurrentPage(currentPage - 1);
                                window.scroll(0, 0);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "mx-1",
                                children: "previous"
                            })
                        })
                    }, "pagination-previous"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: classnames_default()("mx-1 select-none rounded-lg px-3 py-2", currentPage >= nbPages ? "bg-indigo-100 text-gray-500" : "bg-indigo-900 text-white"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: classnames_default()("flex items-center font-bold", currentPage >= nbPages ? "cursor-default" : ""),
                            onClick: function(event) {
                                event.preventDefault();
                                if (currentPage >= nbPages) {
                                    return false;
                                }
                                setCurrentPage(currentPage + 1);
                                window.scroll(0, 0);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "mx-1",
                                children: "next"
                            })
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var attractions = (Attractions);


/***/ }),

/***/ 43738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Config; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8100);
/* harmony import */ var utils_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92233);



function Config(param) {
    var children = param.children, fallback = param.fallback;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swr__WEBPACK_IMPORTED_MODULE_1__/* .SWRConfig */ .J$, {
        value: {
            refreshInterval: 1000 * 60 * 2,
            fetcher: function(q, variables) {
                return (0,utils_query__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(q, variables);
            },
            fallback: fallback
        },
        children: children
    });
};


/***/ }),

/***/ 43228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Pagination; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25575);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);

/* eslint-disable react/no-array-index-key */ 


function Pagination(param) {
    var items = param.items;
    var pages = items || [];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
        className: "mb-10 flex",
        "aria-label": "Breadcrumb",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ol", {
            className: "flex space-x-4 rounded-md bg-white px-6 shadow",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    className: "flex",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex items-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                className: "text-gray-400 hover:text-gray-500",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_solid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        className: "h-5 w-5 flex-shrink-0",
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "sr-only",
                                        children: "Home"
                                    })
                                ]
                            })
                        })
                    })
                }),
                pages.map(function(page, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()({
                            "flex last-of-type:hidden md:last-of-type:flex": pages.length > 1
                        }),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                    className: "h-full w-6 flex-shrink-0 text-gray-200",
                                    viewBox: "0 0 24 44",
                                    preserveAspectRatio: "none",
                                    fill: "currentColor",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    "aria-hidden": "true",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        d: "M.293 0l22 22-22 22h1.414l22-22-22-22H.293z"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    href: page.linkAs,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: "ml-4 text-sm font-medium text-gray-500 hover:text-gray-700",
                                        "aria-current": page.current ? "page" : undefined,
                                        children: page.name
                                    })
                                })
                            ]
                        })
                    }, "breadcrumb-".concat(page.name, "-").concat(index));
                })
            ]
        })
    });
};


/***/ }),

/***/ 13693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Card; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/solid/esm/GlobeAltIcon.js


function GlobeAltIcon(props, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M4.083 9h1.946c.089-1.546.383-2.97.837-4.118A6.004 6.004 0 004.083 9zM10 2a8 8 0 100 16 8 8 0 000-16zm0 2c-.076 0-.232.032-.465.262-.238.234-.497.623-.737 1.182-.389.907-.673 2.142-.766 3.556h3.936c-.093-1.414-.377-2.649-.766-3.556-.24-.56-.5-.948-.737-1.182C10.232 4.032 10.076 4 10 4zm3.971 5c-.089-1.546-.383-2.97-.837-4.118A6.004 6.004 0 0115.917 9h-1.946zm-2.003 2H8.032c.093 1.414.377 2.649.766 3.556.24.56.5.948.737 1.182.233.23.389.262.465.262.076 0 .232-.032.465-.262.238-.234.498-.623.737-1.182.389-.907.673-2.142.766-3.556zm1.166 4.118c.454-1.147.748-2.572.837-4.118h1.946a6.004 6.004 0 01-2.783 4.118zm-6.268 0C6.412 13.97 6.118 12.546 6.03 11H4.083a6.004 6.004 0 002.783 4.118z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = react.forwardRef(GlobeAltIcon);
/* harmony default export */ var esm_GlobeAltIcon = (ForwardRef);
// EXTERNAL MODULE: ./context/app.js
var app = __webpack_require__(40714);
// EXTERNAL MODULE: ./components/global/card.module.css
var card_module = __webpack_require__(49969);
var card_module_default = /*#__PURE__*/__webpack_require__.n(card_module);
;// CONCATENATED MODULE: ./components/global/card.jsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

/* eslint-disable @next/next/no-img-element */ 




function Card(_param) {
    var props = _extends({}, _param);
    var link = props.link, image = props.image, title = props.title, type = props.type, additional = props.additional, location = props.location;
    var user = (0,react.useContext)(app/* default */.Z).user;
    // hack
    var isRestroom = title.toLowerCase().includes("restroom");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: link,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            className: "group relative block",
            children: [
                (user === null || user === void 0 ? void 0 : user.CanAccessAdmin) && (location === null || location === void 0 ? void 0 : location.Latitude) && (location === null || location === void 0 ? void 0 : location.Longitude) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute top-0 right-0 z-10 rounded-tr rounded-bl bg-blue-500 p-2",
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_GlobeAltIcon, {
                        className: "h-4 w-4 fill-white"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    "aria-hidden": "true",
                    className: "aspect-w-16 aspect-h-9 overflow-hidden rounded-lg group-hover:opacity-75",
                    children: image ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "https://images.opencoaster.com/800x400/".concat(image.hash).concat(image.ext),
                        srcSet: "\n                https://images.opencoaster.com/800x400/".concat(image.hash).concat(image.ext, " 800w,\n                https://images.opencoaster.com/600x300/").concat(image.hash).concat(image.ext, " 600w,\n                https://images.opencoaster.com/400x200/").concat(image.hash).concat(image.ext, " 400w,\n                https://images.opencoaster.com/300x150/").concat(image.hash).concat(image.ext, " 300w,\n                https://images.opencoaster.com/200x100/").concat(image.hash).concat(image.ext, " 200w,\n                https://images.opencoaster.com/100x50/").concat(image.hash).concat(image.ext, " 100w\n              "),
                        alt: image.alternativeText ? image.alternativeText : title,
                        className: "h-full w-full object-cover object-center"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h-full w-full bg-gray-200 object-cover object-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-center ".concat((card_module_default()).contents),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "flex",
                                src: "/placeholder-".concat(isRestroom ? "restroom" : type, ".svg"),
                                alt: title
                            })
                        })
                    })
                }),
                additional && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-3 text-sm text-gray-500",
                    children: additional
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "text-base font-semibold text-gray-900 ".concat(!additional ? "mt-3" : ""),
                    children: title
                })
            ]
        })
    });
};


/***/ }),

/***/ 20519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28687);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(graphql_request__WEBPACK_IMPORTED_MODULE_0__);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment MainPhoto on UploadFile {\n    caption\n    alternativeText\n    hash\n    ext\n    width\n    height\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var MainPhoto = (0,graphql_request__WEBPACK_IMPORTED_MODULE_0__.gql)(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (MainPhoto);


/***/ }),

/***/ 82202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28687);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(graphql_request__WEBPACK_IMPORTED_MODULE_0__);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment ParkLite on Parks {\n    id\n    Name\n    Slug\n    MainPhoto {\n      ...MainPhoto\n    }\n    Resort {\n      id\n      Name\n      Slug\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ParkLite = (0,graphql_request__WEBPACK_IMPORTED_MODULE_0__.gql)(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (ParkLite);


/***/ }),

/***/ 70590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ formatNumber; }
/* harmony export */ });
/* eslint-disable import/prefer-default-export */ var formatNumber = function(number) {
    return new Intl.NumberFormat().format(number);
};


/***/ }),

/***/ 92233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ query1; }
/* harmony export */ });
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28687);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(graphql_request__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_const__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96519);


function query1(query, args) {
    var variables = args;
    var token;
    if (args === null || args === void 0 ? void 0 : args.variables) {
        variables = args.variables;
    }
    if ((args === null || args === void 0 ? void 0 : args.token) && typeof (args === null || args === void 0 ? void 0 : args.token) === "string") {
        token = args.token;
    }
    var client = new graphql_request__WEBPACK_IMPORTED_MODULE_0__.GraphQLClient(utils_const__WEBPACK_IMPORTED_MODULE_1__/* .GRAPH_URL */ .Vd);
    if (token) {
        client.setHeader("authorization", "Bearer ".concat(token));
    }
    return client.request(query, variables);
};


/***/ }),

/***/ 13873:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var RIDE_TYPES = {
    SHOW: {
        name: "Show",
        rideCredit: {
            countLine: "You've watched",
            againAction: "Watch again?",
            removeAction: "Remove a watch",
            claimCredit: "Claim Watch Credit"
        }
    },
    RIDE: {
        name: "Ride",
        rideCredit: {
            countLine: "You've ridden",
            againAction: "Ride again?",
            removeAction: "Remove a ride",
            claimCredit: "Claim Ride Credit"
        }
    },
    CHARACTER_MEET: {
        name: "Character Meet",
        rideCredit: {
            countLine: "You've met",
            againAction: "Meet again?",
            removeAction: "Remove a meet",
            claimCredit: "Claim Character Meet Credit"
        }
    },
    WALK_THROUGH: {
        name: "Walk Through",
        rideCredit: {
            countLine: "You've walked through",
            againAction: "Walk through again?",
            removeAction: "Remove a walk through",
            claimCredit: "Claim Walk Through Credit"
        }
    },
    PLAYGROUND: {
        name: "Playground",
        rideCredit: {
            countLine: "You've played here",
            againAction: "Play again?",
            removeAction: "Remove a play",
            claimCredit: "Claim Playground Credit"
        }
    },
    TRANSPORTATION: {
        name: "Transportation",
        rideCredit: {
            countLine: "You've ridden",
            againAction: "Ride again?",
            removeAction: "Remove a ride",
            claimCredit: "Claim Transportation Credit"
        }
    },
    STREET_PERFORMANCE: {
        name: "Street Performance",
        rideCredit: {
            countLine: "You've watched",
            againAction: "Watch again?",
            removeAction: "Remove a watch",
            claimCredit: "Claim Street Performance Credit"
        }
    },
    SPECTACULAR: {
        name: "Spectacular",
        rideCredit: {
            countLine: "You've watched",
            againAction: "Watch again?",
            removeAction: "Remove a watch",
            claimCredit: "Claim Spectacular Credit"
        }
    },
    PARADE: {
        name: "Parade",
        rideCredit: {
            countLine: "You've watched",
            againAction: "Watch again?",
            removeAction: "Remove a watch",
            claimCredit: "Claim Parade Credit"
        }
    },
    WATER_SLIDE: {
        name: "Waterslide",
        rideCredit: {
            countLine: "You've slid",
            againAction: "Slide again?",
            removeAction: "Remove a slide",
            claimCredit: "Claim Water Slide Credit"
        }
    },
    SLIDE: {
        name: "Slide",
        rideCredit: {
            countLine: "You've slid",
            againAction: "Slide again?",
            removeAction: "Remove a slide",
            claimCredit: "Claim Slide Credit"
        }
    },
    ANIMAL_EXHIBIT: {
        name: "Animal Exhibit",
        rideCredit: {
            countLine: "You've viewed",
            againAction: "View again?",
            removeAction: "Remove a view",
            claimCredit: "Claim Animal Exhibit Credit"
        }
    },
    RETAIL: {
        name: "Retail",
        rideCredit: {
            countLine: "You've shopped",
            againAction: "Shop again?",
            removeAction: "Remove a shop",
            claimCredit: "Claim Shop Credit"
        }
    },
    RESTROOM: {
        name: "Restroom",
        rideCredit: {
            countLine: "You've gone",
            againAction: "Claim again?",
            removeAction: "Remove a restroom",
            claimCredit: "Claim restroom Credit"
        }
    },
    OTHER: {
        name: "Other",
        rideCredit: {
            countLine: "You've experienced this",
            againAction: "Experience again?",
            removeAction: "Remove an experience",
            claimCredit: "Claim Credit"
        }
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (RIDE_TYPES);


/***/ }),

/***/ 49969:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contents":"card_contents__EHihQ"};

/***/ })

}]);